import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import ListItemIcon from '@mui/material/ListItemIcon';
import Checkbox from '@mui/material/Checkbox';
import AccurityIcon from '../../icon/components/AccurityIcon';
export var ColumnTogglerListItem = function (_a) {
    var onClick = _a.onClick, checked = _a.checked, icon = _a.icon, label = _a.label, indeterminate = _a.indeterminate, className = _a.className;
    var iconElement = icon ? (React.createElement(ListItemIcon, { className: "columnToggler__listItemIcon" },
        React.createElement(AccurityIcon, { iconName: icon, fontSize: "small" }))) : null;
    return (React.createElement(ListItem, { onClick: onClick, button: true, className: className },
        React.createElement(ListItemIcon, null,
            React.createElement(Checkbox, { edge: "end", checked: checked, indeterminate: indeterminate, color: "primary", tabIndex: -1, disableRipple: true })),
        React.createElement(ListItemText, null,
            React.createElement(Typography, { noWrap: true }, label)),
        iconElement));
};
//# sourceMappingURL=ColumnTogglerListItem.js.map